/**
 * Mapa «tipo de elemento documentable → módulo de la CMDB donde vive».
 *
 * Lo usa el bloque de documentación de empresa del Dashboard para convertir
 * cada vínculo de un documento (doc_page_links.element_type) en un enlace real
 * al elemento: server → /infrastructure/servers, wifi_ap → /wifi/aps, etc.
 *
 * highlight: el módulo soporta ?destacar=<id> y resalta/centra esa ficha.
 * Los tipos son libres (varchar(50) en la BD), así que un tipo desconocido
 * simplemente no genera enlace: nunca debe romper el listado.
 */

export const DOC_ELEMENTS = {
  server:          { label: 'Servidor',            icon: '🖧',  path: '/infrastructure/servers',        highlight: true },
  storage:         { label: 'Almacenamiento',      icon: '💾',  path: '/infrastructure/storage-arrays' },
  chassis:         { label: 'Chasis',              icon: '📦',  path: '/infrastructure/chassis' },
  rack:            { label: 'Rack',                icon: '🗄️',  path: '/infrastructure/racks' },
  rack_element:    { label: 'Elemento de rack',    icon: '🧱',  path: '/infrastructure/servers' },
  location:        { label: 'Ubicación',           icon: '📍',  path: '/locations' },
  switch:          { label: 'Switch',              icon: '🔀',  path: '/infrastructure/switches' },
  panel:           { label: 'Patch panel',         icon: '🔌',  path: '/infrastructure/patch-panels' },
  pdu:             { label: 'PDU',                 icon: '⚡',  path: '/infrastructure/pdus' },
  ups:             { label: 'SAI / UPS',           icon: '🔋',  path: '/infrastructure/ups',           highlight: true },
  firewall:        { label: 'Firewall',            icon: '🛡️',  path: '/infrastructure/firewalls',      highlight: true },
  router:          { label: 'Router',              icon: '🌐',  path: '/wan/routers',                   highlight: true },
  workstation:     { label: 'Estación de trabajo', icon: '🖥️',  path: '/infrastructure/workstations/list', highlight: true },
  printer:         { label: 'Impresora',           icon: '🖨️',  path: '/infrastructure/printers',       highlight: true },
  peripheral:      { label: 'Periférico',          icon: '🖱️',  path: '/infrastructure/peripherals' },
  ip_phone:        { label: 'Teléfono IP',         icon: '☎️',  path: '/infrastructure/ip-phones' },
  service:         { label: 'Servicio',            icon: '🧩',  path: '/services',                      highlight: true },
  service_farm:    { label: 'Granja de servidores', icon: '🏭', path: '/services/farms' },
  backup_policy:   { label: 'Política de backup',  icon: '🧰',  path: '/backups' },
  database:        { label: 'Base de datos',       icon: '🗃️',  path: '/apps/databases' },
  web_site:        { label: 'Sitio web',           icon: '🌍',  path: '/apps/web-sites' },
  virt_vm:         { label: 'Máquina virtual',     icon: '💻',  path: '/virt/vms',                      highlight: true },
  virt_hypervisor: { label: 'Hypervisor',          icon: '🧊',  path: '/virt/hypervisors' },
  wifi_controller: { label: 'Controlador WiFi',    icon: '📡',  path: '/wifi/controllers',              highlight: true },
  wifi_ap:         { label: 'Punto de acceso',     icon: '📶',  path: '/wifi/aps',                      highlight: true },
  wifi_ssid:       { label: 'Red WiFi (SSID)',     icon: '📻',  path: '/wifi/topology' },
  radius_server:   { label: 'Servidor RADIUS',     icon: '🔐',  path: '/wifi/radius-servers' },
  isp_circuit:     { label: 'Circuito ISP',        icon: '🛰️',  path: '/wan/circuits' },
  ipam_ip:         { label: 'IP',                  icon: '🔢',  path: '/networks/ips' },
  ipam_subnet:     { label: 'Subred',              icon: '🕸️',  path: '/networks/subnets' },
};

/** Ruta del módulo del elemento (con ?destacar= si el módulo lo soporta). */
export function docElementPath(elementType, elementId) {
  const cfg = DOC_ELEMENTS[elementType];
  if (!cfg || !cfg.path) return null;
  if (elementId == null || !cfg.highlight) return cfg.path;
  return `${cfg.path}?destacar=${elementId}`;
}

export function docElementLabel(elementType) {
  return (DOC_ELEMENTS[elementType] || {}).label || elementType || 'Elemento';
}

export function docElementIcon(elementType) {
  return (DOC_ELEMENTS[elementType] || {}).icon || '🧩';
}
